module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-subheader', {
    staticClass: "title",
    attrs: {
      "id": "top"
    }
  }, [_vm._v("USTALENIA MONTAŻOWE")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "accent--text",
    attrs: {
      "label": "Projekt instalacji"
    },
    model: {
      value: (_vm.projekt),
      callback: function($$v) {
        _vm.projekt = $$v
      },
      expression: "projekt"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "col",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Doradztwo techniczne podczas realizacji"
    },
    model: {
      value: (_vm.realizacja),
      callback: function($$v) {
        _vm.realizacja = $$v
      },
      expression: "realizacja"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "col",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Doradztwo w zakresie OSD"
    },
    model: {
      value: (_vm.osd),
      callback: function($$v) {
        _vm.osd = $$v
      },
      expression: "osd"
    }
  })], 1)], 1), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    staticClass: "title2"
  }, [_vm._v("Projekt instalacji fotowoltaicznej")]), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    staticClass: "title3"
  }, [_vm._v("A) Podstawowe dane klienta")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "items": _vm.items,
      "label": "Rodzaj klienta"
    },
    model: {
      value: (_vm.Item.rodzajKlienta),
      callback: function($$v) {
        _vm.$set(_vm.Item, "rodzajKlienta", $$v)
      },
      expression: "Item.rodzajKlienta"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Imię i Nazwisko / Firma"
    },
    model: {
      value: (_vm.Item.nazwa),
      callback: function($$v) {
        _vm.$set(_vm.Item, "nazwa", $$v)
      },
      expression: "Item.nazwa"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Ulica i numer"
    },
    model: {
      value: (_vm.Item.ulica),
      callback: function($$v) {
        _vm.$set(_vm.Item, "ulica", $$v)
      },
      expression: "Item.ulica"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Miejscowość"
    },
    model: {
      value: (_vm.Item.miasto),
      callback: function($$v) {
        _vm.$set(_vm.Item, "miasto", $$v)
      },
      expression: "Item.miasto"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Gmina"
    },
    model: {
      value: (_vm.Item.gmina),
      callback: function($$v) {
        _vm.$set(_vm.Item, "gmina", $$v)
      },
      expression: "Item.gmina"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Kod pocztowy"
    },
    model: {
      value: (_vm.Item.kod),
      callback: function($$v) {
        _vm.$set(_vm.Item, "kod", $$v)
      },
      expression: "Item.kod"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Telefon",
      "type": "tel"
    },
    model: {
      value: (_vm.Item.telefon),
      callback: function($$v) {
        _vm.$set(_vm.Item, "telefon", $$v)
      },
      expression: "Item.telefon"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "E-mail",
      "type": "email"
    },
    model: {
      value: (_vm.Item.email),
      callback: function($$v) {
        _vm.$set(_vm.Item, "email", $$v)
      },
      expression: "Item.email"
    }
  }), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    staticClass: "title3"
  }, [_vm._v("B) Jaką klient rozpatruje moc instalacji np. 4-5kW")]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Moc instalacji [kW]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.moc),
      callback: function($$v) {
        _vm.$set(_vm.Item, "moc", $$v)
      },
      expression: "Item.moc"
    }
  }), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    staticClass: "title3"
  }, [_vm._v("C) Podstawowe wymiary obiektu")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "items": _vm.yesno,
      "label": "Czy istnieje możliwość dołączenia projektu dachu?"
    },
    model: {
      value: (_vm.Item.projektDachu),
      callback: function($$v) {
        _vm.$set(_vm.Item, "projektDachu", $$v)
      },
      expression: "Item.projektDachu"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "items": _vm.rodzajdachu,
      "label": "Rodzaj dachu"
    },
    model: {
      value: (_vm.Item.rodzajDachu),
      callback: function($$v) {
        _vm.$set(_vm.Item, "rodzajDachu", $$v)
      },
      expression: "Item.rodzajDachu"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Długość obiektu [m]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.dlugosc),
      callback: function($$v) {
        _vm.$set(_vm.Item, "dlugosc", $$v)
      },
      expression: "Item.dlugosc"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Szerokość obiektu [m]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.szerokosc),
      callback: function($$v) {
        _vm.$set(_vm.Item, "szerokosc", $$v)
      },
      expression: "Item.szerokosc"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Długość krawędzi dachu [m]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.dlugoscDachu),
      callback: function($$v) {
        _vm.$set(_vm.Item, "dlugoscDachu", $$v)
      },
      expression: "Item.dlugoscDachu"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Kąt pochylenia dachu [°]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.kat),
      callback: function($$v) {
        _vm.$set(_vm.Item, "kat", $$v)
      },
      expression: "Item.kat"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "items": _vm.wymiarybyly,
      "label": "Wymiary zostały"
    },
    model: {
      value: (_vm.Item.wymiaryByly),
      callback: function($$v) {
        _vm.$set(_vm.Item, "wymiaryByly", $$v)
      },
      expression: "Item.wymiaryByly"
    }
  }), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    staticClass: "title3"
  }, [_vm._v("D) Elektryka obiektu")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "items": _vm.istniejaca,
      "label": "Instalacja istniejąca"
    },
    model: {
      value: (_vm.Item.istniejaca),
      callback: function($$v) {
        _vm.$set(_vm.Item, "istniejaca", $$v)
      },
      expression: "Item.istniejaca"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Przekrój przewodów w instalacji elektycznej [mm2]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.przekrojPrzewodu),
      callback: function($$v) {
        _vm.$set(_vm.Item, "przekrojPrzewodu", $$v)
      },
      expression: "Item.przekrojPrzewodu"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Wartość zabezpieczenia przedlicznikowego [A]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.zabezpieczenie),
      callback: function($$v) {
        _vm.$set(_vm.Item, "zabezpieczenie", $$v)
      },
      expression: "Item.zabezpieczenie"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "items": _vm.odgromowa,
      "label": "Instalacja odgromowa"
    },
    model: {
      value: (_vm.Item.odgromowa),
      callback: function($$v) {
        _vm.$set(_vm.Item, "odgromowa", $$v)
      },
      expression: "Item.odgromowa"
    }
  }), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    staticClass: "title2"
  }, [_vm._v("Doradztwo techniczne podczas realizacji")]), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    staticClass: "title3"
  }, [_vm._v("A)")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "items": _vm.izolacja,
      "label": "Instalacja istniejąca"
    },
    model: {
      value: (_vm.Item.izolacja),
      callback: function($$v) {
        _vm.$set(_vm.Item, "izolacja", $$v)
      },
      expression: "Item.izolacja"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "label": "Grubość izolacji [mm]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.gruboscIzlolacji),
      callback: function($$v) {
        _vm.$set(_vm.Item, "gruboscIzlolacji", $$v)
      },
      expression: "Item.gruboscIzlolacji"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "label": "Materiał izloacji"
    },
    model: {
      value: (_vm.Item.materialIzlolacji),
      callback: function($$v) {
        _vm.$set(_vm.Item, "materialIzlolacji", $$v)
      },
      expression: "Item.materialIzlolacji"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "items": _vm.materialkrokwi,
      "label": "Materiał krokwi/płatw"
    },
    model: {
      value: (_vm.Item.materialKrokwi),
      callback: function($$v) {
        _vm.$set(_vm.Item, "materialKrokwi", $$v)
      },
      expression: "Item.materialKrokwi"
    }
  }), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    staticClass: "title3"
  }, [_vm._v("B)")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "items": _vm.typdachu,
      "label": "Rodzaj dachu"
    },
    model: {
      value: (_vm.Item.typDachu),
      callback: function($$v) {
        _vm.$set(_vm.Item, "typDachu", $$v)
      },
      expression: "Item.typDachu"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "label": "Odległość między krokwiami/płatami [mm]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.odlegloscKrokwi),
      callback: function($$v) {
        _vm.$set(_vm.Item, "odlegloscKrokwi", $$v)
      },
      expression: "Item.odlegloscKrokwi"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "label": "Grubość krokwiami/płatwi [mm]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.gruboscKrokwi),
      callback: function($$v) {
        _vm.$set(_vm.Item, "gruboscKrokwi", $$v)
      },
      expression: "Item.gruboscKrokwi"
    }
  }), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    staticClass: "title2"
  }, [_vm._v("Doradztwo w zakresie OSD")]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Nr ewidencyjny działki"
    },
    model: {
      value: (_vm.Item.nrEwidencji),
      callback: function($$v) {
        _vm.$set(_vm.Item, "nrEwidencji", $$v)
      },
      expression: "Item.nrEwidencji"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "items": _vm.dostawca,
      "label": "Dostawca energii elektrycznej"
    },
    model: {
      value: (_vm.Item.dostawca),
      callback: function($$v) {
        _vm.$set(_vm.Item, "dostawca", $$v)
      },
      expression: "Item.dostawca"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Nabywca energii z faktury"
    },
    model: {
      value: (_vm.Item.nabywca),
      callback: function($$v) {
        _vm.$set(_vm.Item, "nabywca", $$v)
      },
      expression: "Item.nabywca"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Wartość zabezpieczenia przedlicznikowego [A]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.wartoscZabezpieczenia),
      callback: function($$v) {
        _vm.$set(_vm.Item, "wartoscZabezpieczenia", $$v)
      },
      expression: "Item.wartoscZabezpieczenia"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Nr PPE (Punkt Poboru Energii)"
    },
    model: {
      value: (_vm.Item.ppe),
      callback: function($$v) {
        _vm.$set(_vm.Item, "ppe", $$v)
      },
      expression: "Item.ppe"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Nr licznika"
    },
    model: {
      value: (_vm.Item.nrLicznika),
      callback: function($$v) {
        _vm.$set(_vm.Item, "nrLicznika", $$v)
      },
      expression: "Item.nrLicznika"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Moc przyłączeniowa [kW]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.mocPrzylaczeniowa),
      callback: function($$v) {
        _vm.$set(_vm.Item, "mocPrzylaczeniowa", $$v)
      },
      expression: "Item.mocPrzylaczeniowa"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Moc umowna [kW]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.mocUmowna),
      callback: function($$v) {
        _vm.$set(_vm.Item, "mocUmowna", $$v)
      },
      expression: "Item.mocUmowna"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.addItem()
      }
    }
  }, [_vm._v("Wyślij")])], 1)], 1), _vm._v(" "), (!_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-557bfce2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Solarspot.vue
// module id = 156
// module chunks = 1